// removed by extract-text-webpack-plugin
module.exports = {"application":"application-cb1a0c"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/application/style.pcss
// module id = ./src/pages/application/style.pcss
// module chunks = 0